// extracted by mini-css-extract-plugin
export var privacyNoticeWrapper = "feedback-module--privacyNoticeWrapper--cb784";